import { render, staticRenderFns } from "./ban.vue?vue&type=template&id=b0d9783e&scoped=true&"
import script from "./ban.vue?vue&type=script&lang=js&"
export * from "./ban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d9783e",
  null
  
)

export default component.exports